import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';

import { HistoryMovement } from 'types';
import movementTypes from 'modules/transactions/constants/movementTypes';

type ReclassificationTableRowProps = {
  index: number;
  movement: HistoryMovement;
};

const ReclassificationTableRow: FC<ReclassificationTableRowProps> = ({
  index,
  movement,
}) => {
  const { t } = useTranslate();

  const isEntireClassReclassification =
    movement.movementType === movementTypes.ENTIRE_CLASS_RECLASSIFICATION;

  return (
    <>
      {isEntireClassReclassification ? (
        <td
          className="tb-tnx-info text-soft text-center"
          colSpan={2}
          key={`movement-entire-${index}`}
        >
          <span className="title">{t('AllRanges')}</span>
        </td>
      ) : (
        <>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-from-${index}`}
          >
            <span className="title">{formatNumber(movement.from)}</span>
          </td>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-to-${index}`}
          >
            <span className="title">{formatNumber(movement.to)}</span>
          </td>
        </>
      )}

      <td className="tb-tnx-info text-left" key={`movement-class-${index}`}>
        <span className="title">{movement.holdingClassName}</span>
      </td>

      {isEntireClassReclassification ? (
        <td
          className="tb-tnx-info text-soft text-center"
          colSpan={2}
          key={`movement-new-entire-${index}`}
        >
          <span className="title">-</span>
        </td>
      ) : (
        <>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-newForm-${index}`}
          >
            <span className="title">{formatNumber(movement.newFrom)}</span>
          </td>
          <td
            className="tb-tnx-info text-soft text-center"
            key={`movement-newTo-${index}`}
          >
            <span className="title">{formatNumber(movement.newTo)}</span>
          </td>
        </>
      )}

      <td className="tb-tnx-info text-left" key={`movement-newClass-${index}`}>
        <span className="title">{movement.newHoldingClassName}</span>
      </td>
    </>
  );
};

export default ReclassificationTableRow;
